import {
  Button,
  Card,
  Grid,
  InputAdornment,
  SvgIcon,
  TextField
} from '@material-ui/core';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { useEventSubscriptions } from 'src/hooks/event-subscriptions/use-event-subscription';
import SearchIcon from '@material-ui/icons/Search';
import { DatePickerRangeComponent } from 'src/components';
import { dateToday, muiDateToYMDHMS } from 'src/utils';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

export const EventsToolbar: FC = () => {
  const {
    filters,
    isLoading,
    setFilters,
    getEventSubscriptionsList
  } = useEventSubscriptions();

  const [keyword, setKeyword] = useState<string | null>(null);
  const [fromDate, setFromDate] = useState<string | null>(null);
  const [toDate, setToDate] = useState<string | null>(null);

  const onChangedDate = useCallback(
    (date: MaterialUiPickersDate | null, field: 'from' | 'to') => {
      const transformedDate = date ? muiDateToYMDHMS(date) : null;

      if (field === 'to') {
        setToDate(transformedDate);
      }
      if (field === 'from') {
        setFromDate(transformedDate);
      }
    },
    []
  );

  const applyFilter = useCallback(() => {
    if (isLoading) return;
    setFilters({
      title: keyword,
      start_date: fromDate,
      end_date: toDate,
      page: 1
    });
  }, [fromDate, isLoading, keyword, setFilters, toDate]);

  useEffect(() => {
    getEventSubscriptionsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  return (
    <Card style={{ padding: '1em' }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            label="Search event"
            value={keyword}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action">
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              )
            }}
            variant="outlined"
            onChange={(e) => setKeyword(e.target.value ?? null)}
            onKeyDown={(e) => e.key === 'Enter' && !isLoading && applyFilter()}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DatePickerRangeComponent
            fromDateMax={dateToday()}
            toDateMin={fromDate ? fromDate : undefined}
            fromDateValue={fromDate || null}
            toDateValue={toDate || null}
            dateToLabel="To Date"
            dateFromLabel="From Date"
            onChangeToDate={(date) => {
              onChangedDate(date, 'to');
            }}
            onChangeFromDate={(date) => {
              onChangedDate(date, 'from');
            }}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <Button
            disabled={isLoading}
            variant="contained"
            color="primary"
            fullWidth
            onClick={applyFilter}
            style={{ height: '100%' }}
          >
            Apply Filter
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};
